import React from 'react';
import { Screen } from '../App/Screen';

export function ErrorPage() {
    return (
        <Screen title="Error">
            <p>An error has occurred</p>
        </Screen>
    );
}